import { z } from "zod";
/**
 * A boolean parsed from a query-string value.
 *
 * `z.coerce.boolean()` is a trap for query params: it does `Boolean(value)`, so
 * ANY non-empty string — including the literal string "false" — becomes `true`
 * (e.g. `?isActive=false` filtered to active rows). This parses "true"/"1"/"yes"
 * (case-insensitive) as `true` and everything else (including "false"/"0"/"") as
 * `false`, and passes real booleans through unchanged (safe for JSON bodies too).
 *
 * Usage: `booleanQueryParam.optional()` in a list query schema.
 */
export const booleanQueryParam = z
    .union([z.boolean(), z.string()])
    .transform((v) => (typeof v === "boolean" ? v : /^(true|1|yes)$/i.test(v.trim())));
//# sourceMappingURL=query-params.js.map